
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Output, OnDestroy, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { BehaviorSubject, first, Observable, Subject, takeUntil } from 'rxjs';

import { environment as env } from '../../../environments/environment';
import { LgvAPIService, LgvClientService, LgvSnapshotHelper, LgvUserService, NotificationService } from '../../core/core.module';
import { GreaterThanZero } from '../../core/utility/lgv-form-validator';
import { LgvModel } from '../../data-models/longevity.model';

@Component({
    selector: 'lus-loan-app-form',
    templateUrl: './loan-app-form.component.html',
    styleUrls: ['./loan-app-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoanAppFormComponent implements OnInit {

    @Output() OnEditLoanStatusChanged: EventEmitter<string> = new EventEmitter();

    _form: UntypedFormGroup;
    isReady: boolean = false;

    agentDTOParam: LgvModel.AgentDTO = null;


    onDestroy$ = new Subject();

    constructor(
        private http: HttpClient,
        private lgvClientSvc: LgvClientService,
        private fb: UntypedFormBuilder,
        public ssHlpr: LgvSnapshotHelper,
        public notificationSvc: NotificationService,
        public dialogRef: MatDialogRef<LoanAppFormComponent>,
        public lgvUserSvc: LgvUserService,
        private lgvApiSvc: LgvAPIService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.agentDTOParam = this.data?.agentDTO;
    }

    ngOnInit() {

        if (!this.agentDTOParam) {
            this.notificationSvc.error('Missing Agent Information');
            return;
        }

        let agentInfo = this.agentDTOParam.agentInfo;

        this._form = this.fb.group({
            firstName: [null, [Validators.required]],
            lastName: [null, [Validators.required]],
            email: [null, [Validators.required]],
            phone: [null, [Validators.required]],
            agent: [{ value: agentInfo.firstName + ' ' + agentInfo.lastName, disabled: true}, [Validators.required]]
        });

        this.isReady = true;
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    onCancel() {
        this.dialogRef.close({ action: false });
    }

    onSubmit() {
        this.dialogRef.close(
            {
                action: true,
                borrowerInfo: this._form.getRawValue()
            }
        );
    }

}

